<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {BoatKind} from "@/modules/redactor/models/boats/BoatKind";

export default {
  name: "r-boat-kind",
  props: {
    model: VueTypes.instanceOf(BoatKind),
    label: VueTypes.string.def("Boat:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return BoatKind.getValues();
    }
  }
}
</script>